export default __webpack_public_path__ + "static/solution_back-0961334108246f0561427eeff531599b.png";